'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var goToTop = {
    controller: function controller($scope, $ionicScrollDelegate, $timeout, $location, $anchorScroll, $rootScope) {
        var _this = this;

        this.scrollDelegate = $ionicScrollDelegate.$getByHandle('mainScroll');

        this.scrollToTop = function () {
            _this.scrollDelegate.scrollTop(true);
            if (!$rootScope.isMobileView) {
                $location.hash('the-top');
                $anchorScroll();
            }
        };

        $timeout(function () {
            document.getElementById('main-content').onscroll = function () {
                _this.controlFade();
            };
        }, 1000);

        this.controlFade = function () {
            var scrollPosition = _this.scrollDelegate.getScrollPosition().top;
            var goToTopButton = document.getElementById('go-to-top');
            if (scrollPosition > 200) {
                goToTopButton.classList.add('mid-opacity');
            } else {
                goToTopButton.classList.remove('mid-opacity');
            }
        };
    },

    template: '<button id="go-to-top" class="button button-picton-blue" ng-click="$ctrl.scrollToTop();">\n                <i class="ion-chevron-up"></i>\n              </button>'
};

exports.default = goToTop;


/** WEBPACK FOOTER **
 ** ./src/app/directives/specialButtons/goToTop.js
 **/